<template>
  <div class="flex flex-col w-64 bg-white flex-no-shrink flex-no-grow border-solid border-r border-grey-lightest">
    <div v-if="!doctor" class="flex flex-col">
      <div class="flex relative flex-row p-1 justify-between self-center flex-no-shrink flex-no-grow">
        <div class="flex flex-row h-10 mr-auto self-center text-xs items-center text-blue font-semibold">
          Doctors
        </div>
      </div>
      <div class="flex flex-row h-1 bg-grey-lightest flex-no-shrink flex-no-grow" />
      <DoctorsList @getDoctor='getDoctor'/>
    </div>
    <div v-else>
      <div class="flex relative flex-row p-1 justify-between items-center flex-no-shrink flex-no-grow">
        <div class="flex flex-row mr-auto justify-center items-center cursor-pointer" @click="goBack()">
          <img src="../../assets/backward arrow.svg" style="height:18px">
        </div>
        <div class="flex flex-row h-10 mr-auto self-center text-xs items-center text-blue font-semibold">
          {{doctor.name + "'s Consultations"}}
        </div>
      </div>
      <div class="flex flex-row h-1 bg-grey-lightest flex-no-shrink flex-no-grow" />
      <DoctorConsultations :doctor='doctor' />
    </div>
  </div>
</template>

<script>
import DoctorsList from '@/components/Admin/DoctorsList'
import DoctorConsultations from '@/components/Admin/DoctorConsultations'
export default {
  components: {
    DoctorsList,
    DoctorConsultations
  },
  data () {
    return {
      doctor: null
    }
  },
  computed: {
  },
  mounted: function () {
  },
  methods: {
    getDoctor: function (doctor) {
      this.doctor = doctor
    },
    goBack: function () {
      this.doctor = null
      this.$store.dispatch('pastConsultation/reset')
    }
  }
}
</script>

<style>
.doctorActive {
  background-color: #dae1e7
}

</style>



// WEBPACK FOOTER //
// src/components/Admin/AdminLeftPane.vue